import {concat, partition} from 'ramda';

export function moveItemToLast<T>(predicate: (item: T) => boolean, array: T[]): T[] {
  const [matching, nonMatching] = partition(predicate, array);
  return concat(nonMatching, matching);
}
